export const PRICING_TYPES = [
    { label: 'Pricing', value: 'PRICING', name: 'Pricing' },
    { label: 'Wholesale Pricing', value: 'WHOLESALE_PRICING', name: 'Wholesale Pricing' },
]